$(function() {

	//タブ切り替え

	$('.ranking_link').click(function(){
		$(".ranking_link").removeClass('is-current');
		$(this).addClass("is-current");
		
		$(".ranking_panel").hide();
		var href= $(this).data('link');
		$(href).fadeIn();
/*
		if(href=="#ranking4"){
    		$('#ranking_navi').animate({scrollLeft: $("#ranking_navi").width()}, 0, 'swing');
    	}
*/		
		var cnt = href.replace("#ranking", "");

		return false;
	});	
	
})
